import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-message",
  "use": "foquz-icon-message-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" id=\"foquz-icon-message\"><path d=\"M11.5 1h-9C1.673 1 1 1.673 1 2.5v6c0 .827.673 1.5 1.5 1.5H5v2.5c0 .23.262.363.448.227L9 10h2.5c.827 0 1.5-.673 1.5-1.5v-6c0-.827-.673-1.5-1.5-1.5z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol